import React from 'react';

interface ButtonProps {
  onClick?: () => void;
  type?: 'button' | 'submit' | 'reset';
  disabled?: boolean;
  children: React.ReactNode;
  style?: React.CSSProperties;
  active?: boolean;
  variant?: 'primary' | 'secondary';
  fullWidth?: boolean;
}

const Button: React.FC<ButtonProps> = ({ 
  onClick, 
  type = 'button', 
  disabled = false, 
  children, 
  style, 
  active = false,
  variant = 'primary',
  fullWidth = false
}) => {
  const getBaseStyle = (): React.CSSProperties => {
    const baseStyle = {
      backgroundColor: variant === 'secondary' ? 'white' : (active ? '#1e1e1e' : '#1e1e1e'),
      color: variant === 'secondary' ? '#1e1e1e' : (active ? 'white' : 'white'),
      border: '1px solid #1e1e1e',
      padding: '0.5rem 1rem',
      borderRadius: '4px',
      cursor: disabled ? 'not-allowed' : 'pointer',
      fontSize: '1rem',
      transition: 'all 0.3s',
      opacity: disabled ? 0.5 : 1,
      width: fullWidth ? '100%' : 'auto',
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '0.5rem'
    };

    return baseStyle;
  };

  const mergedStyle = { ...getBaseStyle(), ...style };

  return (
    <button
      onClick={onClick}
      type={type}
      disabled={disabled}
      style={mergedStyle}
      onMouseOver={(e) => {
        if (!active && !disabled) {
          if (variant === 'secondary') {
            e.currentTarget.style.backgroundColor = '#f1f5f9';
          } else {
            e.currentTarget.style.opacity = '0.9';
          }
        }
      }}
      onMouseOut={(e) => {
        if (!active && !disabled) {
          if (variant === 'secondary') {
            e.currentTarget.style.backgroundColor = 'white';
          } else {
            e.currentTarget.style.opacity = '1';
          }
        }
      }}
    >
      {children}
    </button>
  );
};

export default Button;
